import { createSlice } from "@reduxjs/toolkit";

export const counterSlice = createSlice({
  name: "app",
  initialState: {
    previewModal: { show: false },
    currentPage: 1,
    totalPage: 1,
    posting: false,
    tipsPage: { status: undefined },
    isPreview: false,
    // 预览模式， 1- iframe数据传输预览模式 2- 接口数据传输预览模式
    previewType: undefined,
    // 逻辑验证模式
    previewCheck: false,
    storageModal: false,
    // 获取问卷详情的时间
    firstTime: undefined,
    //多语言数据
    message: "",
    //跳题类型   -2,-3 跳转到末尾 0 下一页
    jumpType: "0",
    isMobile: true,
    surveyInfo: undefined,
  },
  reducers: {
    setPreviewModal: (state, action) => {
      state.previewModal = { ...state.previewModal, ...action.payload };
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPage: (state, action) => {
      state.totalPage = action.payload;
    },
    setPreview: (state, action) => {
      state.previewType = action.payload.previewType;
      state.previewCheck = action.payload.check;
    },
    setStorageModal: (state, action) => {
      state.storageModal = action.payload;
    },
    setFirstTime: (state, action) => {
      state.firstTime = action.payload;
    },
    setTipsPage: (state, action) => {
      state.tipsPage = { status: action.payload.status };
    },
    setMessage: (state, action) => {
      state.message = action.payload;
    },
    setJumpType: (state, action) => {
      state.jumpType = action.payload;
    },
    setPosting: (state, action) => {
      state.posting = action.payload;
    },
    setIsMobile: (state, action) => {
      state.isMobile = action.payload;
    },
    setSurveyInfo: (state, action) => {
      state.surveyInfo = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const appReducersActions = counterSlice.actions;
export default counterSlice.reducer;
